import request from '@/utils/request';
import type { LoginData, LoginResponse, User } from '@/types/auth';

export const authService = {
  login: (data: LoginData): Promise<LoginResponse> => {
    return request.post('/api/admin/auth/login', data);
  },

  logout: () => {
    return request.post('/api/admin/auth/logout');
  },

  getCurrentUser: (): Promise<User> => {
    return request.get('/api/admin/auth/current-user');
  },

  refreshToken: (): Promise<{ token: string }> => {
    return request.post('/api/admin/auth/refresh-token');
  },

  changePassword: (data: { oldPassword: string; newPassword: string }): Promise<void> => {
    return request.post('/api/admin/auth/change-password', data);
  },

  resetPassword: async (email: string): Promise<void> => {
    await request.post('/api/admin/auth/reset-password', { email });
  },
};
